import { render } from "./CenterForm.vue?vue&type=template&id=d6949f3e"
import script from "./CenterForm.vue?vue&type=script&lang=ts"
export * from "./CenterForm.vue?vue&type=script&lang=ts"
script.render = render

export default script